import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { ErrorLayout } from './error-layout'

export default function NotFoundPage({ resetError }: { resetError?: () => void }): JSX.Element {
  const { _t } = useTypedTranslation()

  const handleResetError = () => (resetError ? resetError() : window.location.replace('/'))

  return (
    <ErrorLayout
      buttonId="error-not-found-go-back"
      code={404}
      message={_t('page-not-found')}
      note={_t('page-not-found-note')}
      onReset={handleResetError}
    />
  )
}
